export const getCurrentContinuePath = () => {
  return `${window.location.pathname}${window.location.search}`
}

export const buildLoginContinuePath = (continuePath = getCurrentContinuePath()) => {
  return `/login?continue=${encodeURIComponent(continuePath)}`
}
